import React, { useState, useEffect, useContext } from 'react';

import { IComponentDocument } from '../../component';
import { IDocument, IPPTClip } from '../../store/DocumentStore';

import SwipeableViews from 'react-swipeable-views';
import imageUtil from '../../utils/image.js';

import { ThemeContext } from '../../store/ThemeProvider';

import intl from 'react-intl-universal';
import Switch from '../Common/Switch';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';

import DocumentBigPic from '../BigPic/DocumentBigPic';
import useSimpleBigPic from '../BigPic/useSimpleBigPic';

export interface IDocumentPPT extends IComponentDocument {
  data: IDocument;
  rootStore?: RootStore;
  component_cid: string | number;
  showAuto: boolean;
}

const DocumentPPT = (props: IDocumentPPT) => {
  const { data, auto, rootStore, component_cid, showAuto} = props;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [slides, setSlides] = useState([] as string[]);
  const [useAuto, setUseAuto] = useState(!!auto && showAuto);

  const { componentColor, mainColor, h1Color, h2Color } = useContext(
    ThemeContext
  );
  const [imageList, setImageList] = useState([] as any[]);
  useEffect(() => {
    console.log(`why render and render and render`);
    if (data && data.doc_result) {
      try {
        let list = JSON.parse(data.doc_result);
        setSlides(list);
        setImageList(
          list.map((it: string, index: number) => {
            return {
              id: index + 1,
              hash: it,
              loadStatus: false
            };
          })
        );
      } catch (e) {
        console.log(e);
      }
    }
  }, [data && data.id]);

  const source = rootStore!.videoStore.getVideo(
    data ? Number(data.medium_id) : 0
  );
  const [clipList, setClipList] = useState([] as IPPTClip[]);
  const [lastClipIndex, setLastClipIndex] = useState(0);
  useEffect(() => {
    const onVideoTime = (e: Event) => {
      if (useAuto) {
        let { data } = e;
        let final = lastClipIndex;
        for (var i = lastClipIndex; i < clipList.length; i++) {
          let item = clipList[i];
          if (item && Number(item.second) > Number(data)) {
            final = Math.max(i - 1, 0);
            break;
          }
        }

        if (final != lastClipIndex) {
          setLastClipIndex(final);
        }

        let target = clipList[final] as IPPTClip;
        if (target) setCurrentIndex(Number(target.current));
      }
    };

    if (source) {
      if (
        source.type == 'video' ||
        (source.source_detail && source.source_detail.status == 'rollback')
      ) {
        // 要么是短视频，要么是回放状态
        window.addEventListener(
          `video_time_update_${component_cid}`,
          onVideoTime
        );
      }
    }

    return () => {
      window.removeEventListener(
        `video_time_update_${component_cid}`,
        onVideoTime
      );
    };
  }, [source, clipList, lastClipIndex, useAuto]);

  useEffect(() => {
    if (source) {
      if (
        source.type == 'video' ||
        (source.source_detail && source.source_detail.status == 'rollback')
      ) {
        // 获取自动翻页列表

        let start_time =
          source.type == 'video '
            ? 1
            : source && source.source_detail
            ? Math.round(Date.parse(source.source_detail.begin_at) / 1000)
            : 1;
        let end_time = Math.round(Date.now() / 1000);
        rootStore!.documentStore
          .getClipList(data.id, start_time, end_time)
          .then((res: IPPTClip[]) => {
            setClipList(res);
            setLastClipIndex(0);
          });
      }
    }
  }, [source]);

  useEffect(() => {
    const onDocumentIndexChange = (data: any) => {
      console.log(`on document index change`, data);
      let { current } = data;
      let messageDocumentId = data.document_id;
      if (data && messageDocumentId == data.id) {
        if (useAuto) {
          setCurrentIndex(Number(current));
        }
      }
    };

    if (useAuto) {
      rootStore!.imStore.addMessageListener(
        'document_index_change',
        onDocumentIndexChange
      );
    } else {
      rootStore!.imStore.removeMessageListener(
        'document_index_change',
        onDocumentIndexChange
      );
    }

    return () => {
      rootStore!.imStore.removeMessageListener(
        'document_index_change',
        onDocumentIndexChange
      );
    };
  }, [useAuto]);

  const prep = () => {
    setCurrentIndex(Math.max(0, currentIndex - 1));
  };

  const next = () => {
    setCurrentIndex(Math.min(slides.length - 1, currentIndex + 1));
  };

  const [fullscreen, setFullScreen] = useState(false);
  const [bigIndex, setBigIndex] = useState(-1);
  useEffect(() => {
    if (fullscreen) {
      setBigIndex(currentIndex);
    }
  }, [fullscreen, currentIndex]);

  return (
    <div className="document-ppt">
      <div className="swiper">
        <div style={{ lineHeight: 0 }}>
          <SwipeableViews
            axis="x"
            enableMouseEvents={true}
            index={currentIndex}
            disabled={useAuto}
            onChangeIndex={(e: number) => {
              setCurrentIndex(Number(e));
            }}
            slideStyle={{ overflow: 'hidden' }}
          >
            {slides
              .map((one, index) =>
                Math.abs(index - currentIndex) < 4 ? (
                  <img
                    key={one}
                    src={imageUtil.style(one, 'wx_750_n', null, 1)}
                    alt=""
                    className={'one-head-img'}
                    style={{ width: '100%' }}
                  />
                ) : (
                  <div key={one} />
                )
              )
              .filter(Boolean)}
          </SwipeableViews>
        </div>
        <div className="dots">
          {useAuto ? null : (
            <div
              className="dot-left"
              onClick={prep}
              style={currentIndex == 0 ? { opacity: 0 } : {}}
            >
              <img src={require('../../assets/document_arrow_left.png')} />
            </div>
          )}
          {useAuto ? null : (
            <div
              className="dot-right"
              onClick={next}
              style={currentIndex == slides.length - 1 ? { opacity: 0 } : {}}
            >
              <img src={require('../../assets/document_arrow_right.png')} />
            </div>
          )}
          <div className="dot-fullscreen">
            <img
              src={require('../../assets/document_fullscreen.png')}
              onClick={() => {
                setFullScreen(true);
              }}
            />
          </div>
        </div>
      </div>
      <div className="autopager">
        {typeof auto != 'undefined' && !!auto && showAuto ?<div className="autoswitch">
          <Switch
            value={useAuto}
            onChange={(value: boolean) => {
              setUseAuto(value);
            }}
          />
        </div> : null}
        <div className="swiperinfo" style={{ color: h2Color }}>
          {showAuto ? ((useAuto ? intl.get('DocumentPlayAuto') : intl.get('DocumentPlayCustom')) + intl.get('DocumentDoPager') + ' ') : ''}
          {currentIndex + 1 + '/' + slides.length}
        </div>
      </div>

      <DocumentBigPic
        pageType="documentPPT"
        index={bigIndex}
        list={imageList}
        setIndex={setBigIndex}
        loadFinish={(index: number, size?: number) => {
          console.log(`loadFinish`, index, size);
          setImageList(
            imageList.map((it: any, ind: number) => {
              if (ind == index) {
                it = {
                  ...it,
                  size: size ? size : Math.random()
                };
              }

              return it;
            })
          );
        }}
        onClose={() => {
          setFullScreen(false);
          setBigIndex(-1);
        }}
      />
    </div>
  );
};

export default inject('rootStore')(observer(DocumentPPT));
